import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import Preview from './Preview';
import useUpdateEffect from 'hooks/useUpdateEffect';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ErrorOutlineRounded } from '@material-ui/icons';
import { toBase64 } from '../../helpers';

const useStyles = makeStyles(theme => ({
  input: {
    display: 'none',
  },
  icon: {
    marginRight: '10px',
  },
  buttonInnerContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const FileUpload = ({ initialFiles, onChange, maxNumFiles }) => {
  const classes = useStyles();
  const [files, setFiles] = useState(initialFiles || []);
  const [error, setError] = useState(null);

  const handleFiles = async uploadedFiles => {
    setError(null);
    let doUploadsContainAnExistingFile = false;

    Array.from(uploadedFiles).forEach(uploadedNewFile => {
      files.forEach(existingFile => {
        if (
          existingFile.name === uploadedNewFile.name &&
          existingFile.size === uploadedNewFile.size &&
          existingFile.type === uploadedNewFile.type &&
          existingFile.lastModified === uploadedNewFile.lastModified
        ) {
          doUploadsContainAnExistingFile = true;
        }
      });
    });

    if (doUploadsContainAnExistingFile) {
      setError(`Please only upload unique files.`);
      return;
    }

    if (uploadedFiles.length + files.length > maxNumFiles) {
      setError(`Please limit your uploads to maximum ${maxNumFiles} files.`);
      return;
    }

    const promises = Array.from(uploadedFiles).map(async file => {
      return Object.assign(file, {
        base64: await toBase64(file),
      });
    });

    const uploadedFilesInfo = await Promise.all(promises);

    setFiles([...files, ...uploadedFilesInfo]);
  };

  function handleDelete(fileName) {
    const updatedFiles = [...files];
    const fileIndex = updatedFiles.findIndex(file => file.name === fileName);
    updatedFiles.splice(fileIndex, 1);
    setFiles(updatedFiles);
  }

  useUpdateEffect(() => {
    if (onChange) {
      onChange(files);
    }
  }, [files]);

  return (
    <>
      <div>
        <Button
          variant="contained"
          color="primary"
          component="label"
          disabled={maxNumFiles ? files.length >= maxNumFiles : false}
        >
          <span className={classes.buttonInnerContainer}>
            <PhotoCamera className={classes.icon} /> Upload Files
          </span>
          <input
            accept="image/*"
            className={classes.input}
            id="icon-button-photo"
            onChange={event => handleFiles(event.target.files)}
            type="file"
            multiple
          />
        </Button>
        {error && <FormHelperText error>{error}</FormHelperText>}
      </div>
      {files.length > 0 && <Preview files={files} onClickRemoveFile={handleDelete} isFullPreviewSupported />}
    </>
  );
};

export default FileUpload;
